import React, { useEffect }  from 'react';
import CounterUp from './CounterGlobal';
import WOW from "wowjs";


function AboutTwo() {
    useEffect(() => {
        const wow = new WOW.WOW({
          live: false, // This disables continuous scanning for new elements
        });
        wow.init();
      }, []);
  return (
    <div>
      {/* Start About Area  */}
      <div className="about-area about-style-two tmp-section-gapBottom mt-4">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-thumbnails about-style-two">
                <img
                  src="assets/images/about/about-us.png"
                  alt="Business Consulting about"
                  className="wow zoomIn"
                  data-wow-duration=".8s"
                  data-wow-delay=".3s"
                />
                {/* <div className="dots animated tada">
                  <img
                    className="tada"
                    src="assets/images/about/dots.png"
                    alt="Business Consulting dots"
                  />
                </div> */}
                {/* <div className="scater">
                  <img
                    src="assets/images/about/scater.png"
                    alt="Business Consulting scater"
                  />
                </div> */}
                <div className="tmpk__circle v__1">
                  <svg className="spinner" viewBox="0 0 100 100">
                    <defs>
                      <path
                        id="circle"
                        d="M50,50 m-37,0a37,37 0 1,1 74,0a37,37 0 1,1 -74,0"
                      />
                    </defs>
                    <text>
                      <textPath xlinkHref="#circle">
                        5+ Years Of Working Experience * Experience *
                      </textPath>
                    </text>
                  </svg>
                  <div className="tmpk__circle--icon">
                    <i className="fa-light fa-arrow-right" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inner">
                <div className="section-head section-head-one-side text-align-left">
                  <div className="section-sub-title color-secondary">
                    <span className="subtitle">What We Do</span>
                  </div>
                  <h2 className="title split-collab">
                    Helping your business with
                    <br /> smart, stress free accounting
                  </h2>
                </div>
                <p className="description">
                  Accounting And Business helps individuals and businesses
                  manage their finances. We offer personalized bookkeeping, tax
                  preparations and financial planning services tailored to your
                  goals. We have helped more than 200 businesses and individuals
                  in our 5 year venture. Our client base consists of businesses
                  from all sectors. From startups to well established businesses
                  and small ventures to growing corporations. We have served all
                  industries. We are proud that our business has flourished due
                  to the personal connection we have created with our clients
                  which leads them to refer us to anyone that needs financial
                  services.
                </p>
                <div className="feature-counter">
                  <div className="tmp-feature-wrapper">
                    <h3 className="title">Grow Your Business</h3>
                    <div className="tmp-feature">
                      <div className="icon bg-color-secondary-alt radius-circle">
                        <i className="fa-regular fa-check small-icon" />
                      </div>
                      <div className="feature-content">
                        <h6 className="title">
                          Bookkeeping & tax services.
                        </h6>
                      </div>
                    </div>
                    <div className="tmp-feature">
                      <div className="icon bg-color-secondary-alt radius-circle">
                        <i className="fa-regular fa-check small-icon" />
                      </div>
                      <div className="feature-content">
                        <h6 className="title">For startups to large firms.</h6>
                      </div>
                    </div>
                    <div className="tmp-feature">
                      <div className="icon bg-color-secondary-alt radius-circle">
                        <i className="fa-regular fa-check small-icon" />
                      </div>
                      <div className="feature-content">
                        <h6 className="title">Across all industries.</h6>
                      </div>
                    </div>
                    <div className="tmp-feature">
                      <div className="icon bg-color-secondary-alt radius-circle">
                        <i className="fa-regular fa-check small-icon" />
                      </div>
                      <div className="feature-content">
                        <h6 className="title">Trusted by loyal clients.</h6>
                      </div>
                    </div>
                  </div>
                  <div className="counter-wrapper counter-style-one">
                    <div className="counter-inner">
                      <CounterUp end={1548} />
                      <p className="description">
                        Projects completed <br /> in last 5 years
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End About Area  */}
    </div>
  );
}

export default AboutTwo